// extracted by mini-css-extract-plugin
export default {"addressSection":"ZT-z","disabled":"_T-z","sectionButtons":"aU-z","logo":"bU-z"};